import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { discountMobx } from 'restaurant'
import { payChannelMobx } from '@mobxStore'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  show: boolean;
  onClick?: () => void;
}

const PayAndRechargeTip: FC<IProps> = ({ show, onClick }) => {
  // 不展示
  if (!show || !payChannelMobx.availableMemberCardMethod) return null

  return (
    <div className='pay-and-recharge-tip-wrapper' data-cypid='payAndRechargeTip' onClick={onClick}>
      {
        discountMobx.discountResult.onlyBalancePayMoreOff ? (
          <>
            <span>{i18n.t('pay.payAndRecharge.useBalance')}</span>
            <span className='use-reduce' dangerouslySetInnerHTML={{ __html: i18n.t('pay.payAndRecharge.useBalanceReduce', { amount: `<big>${format.toPriceLittleCurrency(discountMobx.discountResult.onlyBalancePayMoreOff)}</big>` }) }}></span>
          </>
        ) : <span>{i18n.t('pay.payAndRecharge.useBalanceConvenient')}</span>
      }
      <i className='iconfont icon-jiantou'></i>
    </div>
  )
}

export default observer(PayAndRechargeTip)
